<app-tab-bar [tabs]="tabList" [currentTab]="currentTab"
             (updateCurrentIndex)="getIndexValue($event)"></app-tab-bar>
<div class="site-content">
  <div class="section" style="padding: 0" *ngIf="response">
    <div class="section-identifier">
      <div class="index-name"> {{response.indexName}}</div>
      <span>Ticker: </span> <span>{{response.id}}</span>
    </div>
    <div class="index-family-bar">
    </div>
    <div class="section-quantifier">
      <table>
        <tr>
          <td>As Of Date</td>
          <td>Total Return</td>
          <td>Total Return % Change</td>
          <td *ngIf="!currentID.includes('CCA') && !currentID.includes('EUA')">Weighted Carbon Price</td>
          <td>Price Return % Change</td>
        </tr>
        <tr>
          <td>{{this.utilService.formatDate(response.asOf)}}</td>
          <td>{{response.totalReturn | number: '1.2-4'}}</td>
          <td>{{(response.totalReturnPercentage * 100) | number: '1.2-4'}}</td>
          <td *ngIf="!currentID.includes('CCA') && !currentID.includes('EUA')">{{response.weightedCarbonPrice | number: '1.2-4'}}</td>
          <td>{{(response.priceReturnPercentage * 100) | number: '1.2-4'}}</td>
        </tr>
      </table>
    </div>
    <div style="display: flex" *ngIf="expanded">
      <div style="width: 2%; border-bottom: 8px solid #f0f1f2; padding: 8px 10px;">
        <i class="site-icon-back pointer-cursor" (click)="expandView('CHART')"></i>
      </div>
      <app-tab-bar style="width: 98%" [tabs]="cards" [dynamicTabs]="false"
                   [currentTab]="currentCard" (updateCurrentIndex)="changeView($event)"></app-tab-bar>
    </div>
  </div>
  <div class="section" *ngIf="!response">
    No data to show
  </div>
  <div class="sub-section">
    <div class="card" [hidden]="!visibleCards.includes('chart')" [ngStyle]="{'margin-top': expanded ? '0' : '10px'}">
      <div class="card-header" style="display: flex; padding: 0.5rem 1rem 0 1rem; align-items: center">
        <span> Chart </span>
        <div class="chart-options-parent">
          <div style="display: flex; margin-bottom: 5px">
            <div style="width: 150px; margin-right: 8px">
              <span>Period</span>
              <app-ihsm-dropdown-lib dropdownType="single" [data]="period"
                                   (filterAppliedEvent)="applyPeriodFilter()"></app-ihsm-dropdown-lib>
            </div>
            <div style="width: 230px">
              <span>Date Picker</span>
              <app-range-date-select [dateRange]="dateRange" (filterChanged)="setDateRange($event)"></app-range-date-select>
            </div>
            <div style="width: 180px;">
              <span>Timeseries</span>
              <app-ihsm-dropdown-lib dropdownType="single" [data]="timeSeries"
                                   (filterAppliedEvent)="applyTimeSeriesFilter()"></app-ihsm-dropdown-lib>
            </div>
          </div>
          <span class="clear-filter primary-color pointer-cursor" style="width: 80px;margin-top: 15px" (click)="resetChart()"
                [ngStyle]="{'visibility': chartSetting === 'default' ? 'hidden' : 'visible'}"> Reset Chart</span>
          <button class="button" style="margin-top: 15px" (click)="downloadHistory()"> Download History</button>
        </div>
        <i class="site-icon-maximise primary-color pointer-cursor" *ngIf="!expanded" (click)="expandView('CHART')"></i>
        <i class="site-icon-minimise primary-color pointer-cursor" *ngIf="expanded" (click)="expandView('CHART')"></i>
      </div>
      <div class="card-body" *ngIf="chartDataLoaded">
        <app-chart-page [indexID]="currentID" [timePeriod]="currentPeriod" [chartData]="chartData"></app-chart-page>
      </div>
      <div class="card-body" *ngIf="chartData.chartSeries.data.length === 0">
        <div class="no-data-display">
          No Data to display
        </div>
      </div>
    </div>
  </div>
  <div class="sub-section" [ngStyle]="{'display': expanded ? 'inline' : 'flex'}">
    <div class="card index-performance-card" [ngStyle]="{'width': expanded ? '99%' : '50%', 'margin-top': expanded ? '0' : '5px'}"
         [hidden]="!visibleCards.includes('analytics')">
      <div class="card-header">
        <span> Index Performance & Analytics </span>
        <i class="site-icon-maximise primary-color pointer-cursor" *ngIf="!expanded" (click)="expandView('INDEX PERFORMANCE & ANALYTICS')"></i>
        <i class="site-icon-minimise primary-color pointer-cursor" *ngIf="expanded" (click)="expandView('INDEX PERFORMANCE & ANALYTICS')"></i>
      </div>
      <div class="card-body" *ngIf="response">
        <app-index-performance-analytics-page [indexType]="'carbon'" [indexData]="response"></app-index-performance-analytics-page>
      </div>
      <div class="section" *ngIf="!response">
        No data to show
      </div>
    </div>
    <div class="card index-constituent-card" [ngStyle]="{'width': expanded ? '99%' : '50%', 'margin-top': expanded ? '0' : '5px'}"
         [hidden]="!visibleCards.includes('constituent')">
      <div class="card-header">
        <span> Index Constituents </span>
        <i class="site-icon-maximise primary-color pointer-cursor" *ngIf="!expanded" (click)="expandView('CONSTITUENT')"></i>
        <i class="site-icon-minimise primary-color pointer-cursor" *ngIf="expanded" (click)="expandView('CONSTITUENT')"></i>
      </div>
      <div class="card-body" *ngIf="constituentData">
        <app-index-costituent-page [indexType]="'carbon'" [expanded]="expanded" [constituentData]="constituentData"></app-index-costituent-page>
      </div>
      <div class="section" *ngIf="!constituentData">
        No data to show
      </div>

    </div>
  </div>
</div>
<lib-ihsm-alert-notification class="alert-box index-details" *ngIf="showAlert1" [message]="alert1" (close)="closeAlert('alert1')" [messageType]="alertType"></lib-ihsm-alert-notification>
<lib-ihsm-alert-notification class="alert-box chart-data" *ngIf="showAlert2" [message]="alert2" (close)="closeAlert('alert2')" [messageType]="alertType"></lib-ihsm-alert-notification>
<lib-ihsm-alert-notification class="alert-box constituent-data" *ngIf="showAlert3" [message]="alert3" (close)="closeAlert('alert3')" [messageType]="alertType"></lib-ihsm-alert-notification>
<lib-ihsm-alert-notification class="alert-box headline-data" *ngIf="indexNotInHeadline" [message]="indexNotFoundMsg"
                             (close)="closeAlert('indexNotFoundMsg')" [messageType]="'error'"></lib-ihsm-alert-notification>

